import React from "react";
import { useNavigate } from "react-router-dom";
import { BusinessPage, ButtonText } from "core/constants";
import { useUpdatePage } from "core/hooks";
import PaymentResult from "./components/payment-result";
import Button from "components/ui/form/button";

const Success = () => {
    const navigate = useNavigate();
    const [updateTitle,] = useUpdatePage();
    const goBackToDashboard = (event: any) => navigate(BusinessPage.dashboard);

    updateTitle("- Payment: Success");

    return (
        <section className="payment-result">
            <i className="result-icon icon-success"></i>

            <h1>Payment Successful</h1>

            <PaymentResult />

            <p className="please-note">
                <strong>Please Note:</strong><br />
                Payments may take a few moments to reflect.
            </p>

            <Button onClick={goBackToDashboard} text={ButtonText.goBackToDashboard} className="dashboard" />
        </section>
    );
}

export default Success;
